import type { Variant } from '@amplitude/experiment-js-client'

export enum FeatureFlag {
  StickyOrderSummaryMobile = 'sticky-order-summary-mobile',
  AiReview = 'ai-review',
  ReferFriend = 'refer-friend',
  ReferFriendMenuPopover = 'refer-friend-menu-popover',
  RefererFriend = 'referer-friend',
  ClickRewardsCertificates = 'click_rewards_certificates',
}

export type FeatureFlagVariant<V = 'enabled' | 'disabled'> = Variant & { value?: V }
export type RefererFriendVariant = FeatureFlagVariant<'control_no_badge' | 'red_badge'>

export interface FeatureFlagConfig extends Record<FeatureFlag, Variant> {
  [FeatureFlag.StickyOrderSummaryMobile]: FeatureFlagVariant
  [FeatureFlag.AiReview]: FeatureFlagVariant
  [FeatureFlag.ReferFriend]: FeatureFlagVariant
  [FeatureFlag.ReferFriendMenuPopover]: FeatureFlagVariant
  [FeatureFlag.RefererFriend]: RefererFriendVariant
  [FeatureFlag.ClickRewardsCertificates]: FeatureFlagVariant
}
